import enStringTable from "./en"
import zhStringTable from "./zh"
import jaStringTable from "./ja"

var Fallback = "en"
// var locale = 'en'
var defaultLocale = "en"

class StringHelper {

	// static setLoacle(newValue){
	// 	// locale = newValue
	// }

	static getLocale() {
		const userSeletced = StringHelper.getUserSelectedLocale()
		if(userSeletced != null){
			return userSeletced
		}
		return StringHelper.getDefaultLocale()
	}

	static getString(key) {
		let value = "";
		let locale = StringHelper.getLocale();
		let stringTable;
		switch(locale) {
			case "zh": stringTable = zhStringTable; break;
			case "ja": stringTable = jaStringTable; break;
			default: stringTable = enStringTable;
		}
		if(stringTable[key] === undefined){
			console.error("text: ", key, "not found.")
			// do failback
			if(enStringTable[key] == undefined){

				console.error("text: ", key, " did not in english table.")
				return `{${key}}`
			}else{
				return enStringTable[key]
			}

		}
		return stringTable[key]
	}

	static setDefaultLoacle(newValue) {
		defaultLocale = newValue
	}

	static getDefaultLocale() {
		return defaultLocale
	}

	static getUserSelectedLocale() {
		const selectedLanguage = localStorage.getItem("selectedLanguage");
		return selectedLanguage
	}

	static setUserSelectedLocale(newValue) {
		if(newValue == null){
			window.localStorage.removeItem("selectedLanguage")
		}else{
			window.localStorage.setItem("selectedLanguage", newValue)
		}
	}


}

function _(key){
	return StringHelper.getString(key)
}

export { StringHelper, _ }

